<template>

    <v-card width="580" height="420"
            v-if="!hidden"
            :flat="presentationMode"
            :class="widgetCardClass">

        <material-header v-if="!presentationMode"
                :opacity="presentationMode ? 0.5 : 1"
                         :dense="true"
                         :title="title"
                         :info="info"
                         :loading="loading"
                         disable-icon
                         toolbar-color="grey darken-3">

            <template slot="buttons" v-if="!presentationMode">
                <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn v-show="hasConfigOptions" icon v-on="on" @click="">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="(config, index) in configOptions" :key="index"
                                     @click.stop="configChanged(config.value)">
                            {{config.name}}
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-btn icon @click="refreshComponent(widget.name)">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </template>
        </material-header>

        <v-toolbar-title class="title pl-2 pb-1 text-center" v-if="presentationMode && titleVisible">
            {{title}} <span v-if="info.length>0">| </span>
            <span v-if="info.length>0"
                  class="subtitle-1 grey--text text--lighten-1">
                    {{info}}
                </span>
        </v-toolbar-title>

        <v-card-text v-if="insufficientData" class="text-center">
            <div style="margin-top: 100px;">
                <v-icon :color="chargeIconColor" x-large dark>mdi-battery-charging-100</v-icon>
            </div>
            <div class="headline grey--text text--darken-1">{{insufficientDataTitle}}</div>
            <div class="normal grey--text text--darken-1">{{insufficientDataSubTitle}}</div>
        </v-card-text>

        <v-card-text v-if="!insufficientData" style="height: 85%" class="text-center">

            <component
                    :is="widget.name"
                    @remove="removeComponent"
                    @settings="setSettings"
                    :name="widget.name"
                    @loading-ended="loading=false"
                    @loading-started="loading=true"
                    @insufficient-data="insufficientDataEvent"
                    @sufficient-data="sufficientDataEvent"
                    @hide-title="titleVisible=false"
            ></component>

        </v-card-text>
    </v-card>

</template>

<script>

    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import PanelGrowth from './PanelGrowth';
    import ProjectActivityStats from './ProjectActivityStats';
    import CompletesCounter from './CompletesCounter';
    import ProjectLeader from './ProjectLeader';
    import ActiveEngaged from "./ActiveEngaged";
    import AgeGender from "./AgeGender";
    import Clock from "./Clock";

    import {mapActions, mapMutations, mapState} from 'vuex';

    export default {

        components: {
            MaterialHeader,

            // TODO: Load dynamically
            PanelGrowth,
            ProjectActivityStats,
            CompletesCounter,
            ProjectLeader,
            ActiveEngaged,
            AgeGender,
            Clock
        },

        props: {
            widget: {
                type: Object,
                required: true,
            },
            presentationMode: {
                type: Boolean,
                required: false,
                default: false
            },
        },

        data() {
            return {
                title: '',
                titleVisible: true,
                info: '',
                loading: false,
                insufficientData: false,
                chargeIconColor: 'grey darken-2',
                hasConfigOptions: false,
                configOptions: [],
                insufficientDataTitle: 'Insufficient data!',
                insufficientDataSubTitle: 'Please check back soon!',
                hidden: false,
            }
        },

        computed: {
            ...mapState('DashBoard', ['widgets']),

            widgetCardClass() {
                if (this.presentationMode) {
                    return "presentationCard";
                }
            }
        },

        methods: {

            ...mapActions('DashBoard', ['updateWidget']),
            ...mapMutations('DashBoard', ['updateWidgetConfig']),

            sufficientDataEvent() {
                this.insufficientData = false;
            },

            insufficientDataEvent(texts) {

                this.insufficientData = true;

                if (texts.title) {
                    this.insufficientDataTitle = texts.title;
                }
                if (texts.subTitle) {
                    this.insufficientDataSubTitle = texts.subTitle;
                }
            },

            refreshComponent() {
                Bus.$emit("refresh-widget-" + this.widget.name);
            },

            removeComponent() {
                this.$emit("remove", this.widget);
            },

            setSettings(data) {
                this.title = data.title;
                this.info = data.info;
                this.hasConfigOptions = data.configs.length > 0;
                this.configOptions = data.configs;
            },

            configChanged(config) {
                this.$emit('config', {name: this.widget.name, active: true, config: config});

                // TODO: Go thru vuex store
                Bus.$emit("config-widget-" + this.widget.name, config);
            }
        },

        created() {

            setInterval(() => {
                this.chargeIconColor = this.chargeIconColor === 'grey darken-1'
                    ? this.chargeIconColor = 'grey darken-2'
                    : this.chargeIconColor = 'grey darken-1';
            }, 1000);
        }
    }
</script>
<style scoped>
    .presentationCard {
        background-color: rgba(0, 0, 0, 0);
    }
</style>